import { Link } from "react-router-dom";
import * as icons from "../../../assets/icons";
import { PlusIcon } from "../../../assets/icons";
import { useNavigationLayout } from "../../../hooks/useNavigationLayout";
import {
  HeaderContainerStyledDiv,
  HeaderMenuItemStyledDiv,
  MenuItemStyledDiv,
} from "../index.styles";

export const MenuItem = ({ handleClose }) => {
  const { items: groups } = useNavigationLayout("global_create");

  return (
    <>
      {groups.map(group => {
        const Icon = icons[group.icon];
        const { key, label, children } = group;

        return (
          <HeaderContainerStyledDiv key={key}>
            <HeaderMenuItemStyledDiv>
              {Icon && <Icon />}
              <span>{label}</span>
            </HeaderMenuItemStyledDiv>

            {(children || []).map(item => {
              const { link, name: itemName, key: itemKey } = item;
              return (
                <MenuItemStyledDiv key={itemKey}>
                  <Link to={link} onClick={handleClose}>
                    <PlusIcon />
                    <span>{itemName}</span>
                  </Link>
                </MenuItemStyledDiv>
              );
            })}
          </HeaderContainerStyledDiv>
        );
      })}
    </>
  );
};
